import React from "react";
import { EventLocation } from "../../types";
import { 
  getListEventLocations, 
  updateEventLocation, 
  createEventLocation, 
  deleteEventLocation 
} from "../../api";
import { BasePanel } from "./BasePanel";


export const EventLocationsPanel: React.FC = () => {
  return (
    <BasePanel<EventLocation>
      config={{
        title: "Luoghi Eventi",
        elementName: "Luogo evento",
        getItems: () => getListEventLocations(),
        createItem: (data) => createEventLocation(data),
        updateItem: (id, data) => updateEventLocation(id, data),
        deleteItem: (id) => deleteEventLocation(id),
        renderItem: (item) => (
          <div className="py-2 flex flex-col sm:flex-row sm:justify-between sm:items-center">
            <span className="text-sm sm:text-base font-medium mb-1 sm:mb-0 lg:min-w-[400px]">
              {item.name}
            </span>
            <span className="text-sm sm:text-base font-medium mb-2 sm:mb-0">
              {item.address} {item.city ? ", " : ""} {item.city}
            </span>
          </div>
        ),
        getTextField: (item) => `${item.name}`,
        fields: [
          { name: "name", label: "Nome", type: "text", required: true },
          { name: "address", label: "Indirizzo", type: "text" },
          { name: "city", label: "Città", type: "text", defaultValue: "Reggio Emilia" },
          { name: "country", label: "Paese", type: "text", required: true, defaultValue: "Italia" },
          { name: "zip_code", label: "Codice postale", type: "number" },
          { name: "latitude", label: "Latitudine", type: "number" },
          { name: "longitude", label: "Longitudine", type: "number" },
        ],
      }}
    />
  )
}